export * from '~/utils/variables.c'

export const ServeType = {
  UNDO: 'undo', // 未服务
  DOING: 'doing', // 服务中
  DONE: 'done', // 已完成
}